type CircularLoaderIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const CircularLoaderIcon = (props: CircularLoaderIconProps) => (
  <svg
    width="234"
    height="234"
    viewBox="0 0 234 234"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="117" cy="117" r="112" stroke="#F0F0F0" strokeWidth="10" />
    <path
      d="M229 117C229 102.292 226.103 87.7279 220.475 74.1395C214.846 60.551 206.596 48.2042 196.196 37.804C185.796 27.4039 173.449 19.154 159.861 13.5255C146.272 7.89696 131.708 5 117 5"
      stroke="#00008F"
      strokeWidth="10"
    />
  </svg>
);
